<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
                    {{ this.$i18n.messages[this.$store.state.locale].search }}
                </el-button>
            </div>
            <div class="pop-content-search">
              <el-form size="mini" @submit.prevent>
                <el-row :gutter="24">
                  <el-col :span="8">
                    <el-form-item label="제조사" label-width="60px">
                      <el-select v-model="form.maker" >
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['maker']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="제품군" label-width="80px">
                      <el-col :span="10">
                        <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                          <el-option value='' label="전체">전체</el-option>
                          <el-option
                              v-for="item in combos['itemGroup']"
                              :key="item.key"
                              :value="item.key"
                              :label="item.value">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="10">
                        <el-select v-model="form.subItemGroup" v-show="changeItemGroupShow">
                          <el-option value='' label="전체">전체</el-option>
                          <el-option
                              v-for="item in combos['subItemGroup']"
                              :key="item.key"
                              :value="item.key"
                              :label="item.value">
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="구분" label-width="60px">
                      <el-input v-model="form.description"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="8" >
                    <el-form-item label="모델" label-width="60px">
                      <el-input v-model="form.modelNm"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="품번" label-width="60px">
                      <el-input v-model="form.itemCd"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="품명" label-width="60px">
                      <el-input v-model="form.itemNm"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="table-area">
                <div class="btn-type1">
                  <el-button type="primary" icon="el-icon-document-add" @click="addItem">
                    추가
                  </el-button>
                </div>
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                        :framework-components="frameworkComponents"
                        :column-defs="columnDefs"
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        :statusBar="statusBar"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady" />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    components: {Layout},
    props: {
      data: {
        Type: Array
        , required: false
      },
    },
    data() {
        return {
          title: '회수자재선택',
          // AG-GRID OPTION [START]
          rowData:[],
          gridOptions: {
            enableColResize: true,
            enableFilter: true,
            animateRows: false,
            enableSorting: true
          },
          frameworkComponents : {
            checkBox: CheckboxCellRenderer,
          },
          form: {
            companyId : 'CENTERLINK',
            maker : '',              // 제조사
            itemGroup : '',          // 제품군
            modelGroup : '',         // 제품상세
            description : '',
            useModelNm : '',
            asAgentId : '3', //this.$store.state.loginInfo.asAgentId TODO:추후 STORE에서 읽어들이도록 수정할것
            itemCd : '',             // 품번
            itemNm : '',             // 품명
            subItemGroup : '',       // 제품상세
            modelNm : '',            // 모델명
            sortType : '',           // 승인/정산처리유형
            page : 1,
            totalPage : 99999,
            curPage : 0,
            totalCount : 99999,
            processTime : '',
            inType: '',
          },
          combos: {
            'maker' : [],            //제조사
            'itemGroup' : [],       //제품군
            'subItemGroup' : [],    //sub제품군
          },
          columnDefs:[
              {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox',
                ellRendererParams: {
                  trueValue: true    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                  , falseValue: false  //false값 지정 defalut-"N" ex) "N", false, "0"
                  , disable: true
                },
              },
              {headerName: '제품군', width:120, field:'itemGroupNm', cellStyle:{textAlign:'center'}},
              {headerName: '품번', width:180, field:'itemCd', cellStyle:{textAlign:'left'}},
              {headerName: '대표모델', width:180, field:'useModelNm', cellStyle:{textAlign:'left'}},
              {headerName: '품명', width:180, field:'itemNm', cellStyle:{textAlign:'left'}},
              {headerName: '규격', width:180, field:'itemSpec', cellStyle:{textAlign:'left'}},
              {headerName:'수량', field:'goodQty', width:110, cellStyle : {textAlign: 'right'},
                valueFormatter: (params) => {
                  return this.chkNumber(params, '', '');
                }},
          ],
          defaultColDef: {
              resizable: true,
              filter:true,
              sortable: true
          },
          statusBar: null,
          changeItemGroupShow : false,
        }
    },
    mounted() {
    },
    created() {
      this.form.modelNm = this.data.modelNm;
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
    methods: {
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(event) {
            console.log('add onCellClicked  start===', event)
            this.$emit('close', event);
            this.closeModal();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 고객구분
              this.getMakerCombo();
              this.getItemGroupCombo();
              this.getItemGroupValue();
            } else {
            }
        },
        getItemGroupValue(){

          if(this.data.modelGroup !== undefined && this.data.modelGroup.length > 0){

            const vform = {
              topKey: 'ModelGroup',
              catKey: this.data.modelGroup
            }

            this.$http.get(`/api/codeMng/detail`, { params: vform })
                .then(response => {
                  if(response.data.length === 1){
                    if(response.data[0].catLvl > 2){
                      this.setItemGroupSubValue(response.data[0])
                    } else {
                      this.form.itemGroup = response.data[0].catKey
                    }
                  }
                });
          }
        },
        setItemGroupSubValue(params){
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: params.parentId} })
              .then(response => {
                this.combos['subItemGroup'] = response.data || []
                this.form.subItemGroup = params.catKey
                this.setItemGroupValue(params);
              });
        },
        setItemGroupValue(params) {
          this.$http.get(`/api/codeMng/detail/catId`, {params: {catId: params.parentId}})
              .then(response => {
                this.form.itemGroup = response.data[0].catKey
                this.changeItemGroupShow =  true
              })
        },
        getMakerCombo(){
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
              .then(response => {
                this.combos['maker'] = response.data || []
              });
        },
        getItemGroupCombo(){
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
              .then(response => {
                this.combos['itemGroup'] = response.data || []
              });
        },
        onItemGroupChange(param){
          this.form.subItemGroup = '';
          if(param === '') this.changeItemGroupShow =  false;
          else{
            this.changeItemGroupShow =  true
            // 제품군
            this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
                .then(response => {
                  let subData = response.data.filter(x => x.catKey === param);
                  this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                      .then(response => {
                        this.combos['subItemGroup'] = response.data || []
                      });
                });
          }
        },
        goOpen(){
            this.$store.commit('loading')
            const vForm = {
              companyId :this.form.companyId,
              maker : this.form.maker,                         // 제조사
              itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
              modelGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
              description : this.form.description,
              useModelNm : this.form.useModelNm,
              asAgentId : this.form.asAgentId,
              itemCd : this.form.itemCd,                       // 품번
              itemNm : this.form.itemNm,                       // 품명
              subItemGroup: '',                                // 제품군 상세
              modelNm : this.form.modelNm,                     // 모델명
              sortType : this.form.sortType,
              page : this.form.page,
              totalPage : this.form.totalPage,
              curPage : this.form.curPage,
              totalCount : this.form.totalCount,
              processTime : this.form.processTime,
              userId: this.$store.state.loginInfo.id
            }

            //모델 inputBox에 text 기입시 분기 처리 되어있음(as-is)
            let postUrl;
            if (this.form.modelNm === '') postUrl = "/api/workMng/mateEntering/popup/list";
            else postUrl = "/api/workMng/reqMateEnter/popup/list";

            this.$http.post((postUrl), vForm)
                .then(response => {
                  this.rowData = response.data;
                  /* data customize */
                  //this.changeData();
            }).finally(() => {
                this.$store.commit('finish')
            });
        },
        chkNumber(params, flag, excRt){
          var result = '';
          var val = params.value;
          var data = this.data;

          if(flag === 'sub') data = this.subData;

          if(!_.isEmpty(val) || _.isNumber(val)){
            val = val.toString();

            if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
            else result = this.$numeral(val).format('0,0');

            //data[params.node.id][params.column.colId] = this.$numeral(val).value();
          }

          return result
        },
        addItem(param){
          /** 추가 */
          let list = this.rowData.filter(v => v.chk);

          if(param && param.length === 1) {
            list = param;
          }

          if(list.length == 0){
            this.$swal({ type: 'warning', text: '사용자재를 선택해주세요.'});
            return false;
          }
          console.log(list);
          this.$emit('close', list);
        },
        /* data customize */
        changeData(){
          this.rowData.map((x, i) => {
            let filterSiteType = this.combos['siteType'].filter(y => y.key === x.siteType);
          })
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>